<template>
  <div class="login">
    <app-header />
    <div class="login-content">
      <Card header="Login" type="secondary">
        <form class="form" @submit.prevent="onLogin">
          <div class="form-content">
            <ag-form-group label="Email" id="email">
              <ag-input id="email" :value="email" @change="email = $event" />
            </ag-form-group>
            <ag-form-group label="Password" id="password">
              <ag-input
                id="password"
                type="password"
                :value="password"
                @change="password = $event"
              />
            </ag-form-group>
          </div>
          <div v-if="errorMessage">
            {{ errorMessage }}
          </div>
          <ag-button type="submit" :disabled="!isFormValid">Submit</ag-button>
        </form>
      </Card>
    </div>
    <!-- <div class="alternate-option">
      <div>Don't have an account?</div>
      <router-link :to="{ name: 'Register' }">Register</router-link>
    </div> -->
  </div>
</template>

<script>
  import { get, isEmpty } from "lodash";
  import Card from "../components/Card";
  import AppHeader from "@/components/Header";

  export default {
    name: "Login",
    data: () => ({
      email: "",
      password: "",
      errorMessage: ""
    }),
    computed: {
      isFormValid() {
        return !isEmpty(this.email) && !isEmpty(this.password);
      }
    },
    methods: {
      async onLogin() {
        this.errorMessage = "";
        try {
          await this.$store.dispatch(this.$action.USER.LOGIN, {
            email: this.email,
            password: this.password
          });
          this.$router.push({ name: "Recipes" });
        } catch (error) {
          // TODO Move this to Axios interceptor
          if ([401, 403].includes(get(error, "response.status"))) {
            this.errorMessage = "Wrong Username or Password.";
          } else {
            console.error("Error logging in", error);
            this.errorMessage = "Oops, something went wrong, please try again.";
          }
        }
      }
    },
    components: { Card, AppHeader }
  };
</script>

<style scoped lang="scss">
  .login-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    padding: $gutter;

    .header {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .form {
      flex-grow: 1;
      display: flex;
      flex-direction: column;

      .form-content {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .form-group {
          width: 100%;
          max-width: 500px;
        }
      }
    }

    .alternate-option {
      padding: 20px;
      text-align: center;
      line-height: 1.4em;
    }
  }
</style>
